import { pedagogico } from "@/constants/pedagogico";
import { secretaria_financeiro } from "@/constants/secretaria_financeiro";

function getPrazo(setor, servico) {
  const servicos = setor === "pedagogico" ? pedagogico : secretaria_financeiro
  const data = servicos?.find(element => element.id === servico);
  return data.prazo_minutos || 0
}

export default getPrazo;
